import { api } from './api';

// Assinaturas mantidas do mock original pra minimizar impacto nos consumidores.
// login/signup agora retornam { user, stores, token, refreshToken } — os callers
// no AuthContext foram atualizados pra consumir isso.

export const authService = {
  // Primeiro arg pode ser email, CPF ou telefone. Nome do parâmetro mantido
  // como 'email' pra não quebrar callers antigos. Mandamos `identifier` pro
  // backend — o validator aceita o legado `email` também, mas preferimos o
  // caminho novo.
  login: async (emailOrIdentifier, password) => {
    return api.post(
      '/api/auth/login',
      { identifier: emailOrIdentifier, password },
      { includeAuth: false, includeStore: false }
    );
  },

  signup: async (userData) => {
    // userData pode vir com type: 'reviter'|'supplier'|'client' (legado) — mapeia pra role.
    const LEGACY = { reviter: 'reseller', supplier: 'store_owner', client: 'client' };
    const role = userData.role || LEGACY[userData.type] || 'client';
    return api.post('/api/auth/register', {
      email: userData.email,
      password: userData.password,
      name: userData.name,
      phone: userData.phone || null,
      cpf: userData.cpf || null,
      role,
      preferredLanguage: userData.preferredLanguage || 'pt-BR'
    }, { includeAuth: false, includeStore: false });
  },

  getProfile: async () => {
    return api.get('/api/auth/profile', { includeStore: false });
  },

  refresh: async (refreshToken) => {
    return api.post('/api/auth/refresh', { refreshToken }, { includeAuth: false, includeStore: false });
  },

  logout: async () => {
    try {
      await api.post('/api/auth/logout', null, { includeStore: false });
    } catch {
      // no-op server-side de qualquer jeito
    }
  },

  // Atualiza perfil do user logado. Aceita { name, phone, email, preferredLanguage,
  // currentPassword, newPassword }. Se newPassword, currentPassword é obrigatório.
  // O primeiro arg (_userId) é ignorado — mantido por compat com calls antigas.
  updateProfile: async (_userId, userData) => {
    return api.patch('/api/auth/profile', userData, { includeStore: false });
  },

  forgotPassword: async (email) => {
    return api.post('/api/auth/forgot-password', { email }, { includeAuth: false, includeStore: false });
  },

  resetPassword: async (token, newPassword) => {
    return api.post('/api/auth/reset-password', { token, newPassword }, { includeAuth: false, includeStore: false });
  },

  // Troca de senha pelo próprio usuário autenticado (Doc Seção 9 — /minha-conta).
  changePassword: async (currentPassword, newPassword) => {
    return api.patch('/api/auth/password', { currentPassword, newPassword }, { includeStore: false });
  }
};

export default authService;
